export default "__VITE_ASSET__DbEJucG5__"